<template>
  <jet-authentication-card>
    <AppHead title="Log In" />

    <p v-if="Object.keys($page.props.errors).length" class="alert alert-danger"><i class="fas fa-exclamation-circle mr-2"></i>Your email or password doesn't match our records, double check your credentials and try again.</p>

    <p v-if="isOffline" class="alert alert-danger"><i class="fas fa-wifi mr-2"></i>You appear to be offline, we were not able to log you in. Please try again</p>

    <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
      {{ status }}
    </div>

    <template #logo>
      <jet-authentication-card-logo />
    </template>

    <form @submit.prevent="submit" method="post">
      <div class="p-3">
        <div class="row">
          <div class="col-12 col-lg-5">
            <InteractiveInput 
              icon="fas fa-envelope" 
              formLabel="Email"
              v-model="form.email"
              :error="Object.keys($page.props.errors).length"
              class="my-1 my-lg-0"
              :formAttr="{
                id: 'email',
                type: 'email',
                required: true,
                autofocus: true,
                classes: 'form-control',
                modelValue: form.email
              }"/>
          </div>

          <div class="col-12 col-lg-5">
            <InteractiveInput 
              icon="fas fa-lock" 
              formLabel="Password"
              v-model="form.password"
              :error="Object.keys($page.props.errors).length"
              class="my-1 my-lg-0"
              :formAttr="{
                id: 'password',
                type: 'password',
                classes: 'form-control',
                required: true,
                modelValue: form.password
              }"/>
          </div>

          <div class="col-12 col-lg-2 d-flex align-items-end">
            <jet-button icon="fas fa-sign-in-alt" class="text-nowrap mt-4 mt-lg-3 mt-lg-0 m-w-100" type="submit" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
              Log in
            </jet-button>
          </div>
        </div>

        <div class="form-check mt-3">
          <jet-checkbox name="remember" v-model:checked="form.remember" />
          <label class="mb-0">Remember Me</label>
        </div>

        <hr class="my-1">
        
        <inertia-link v-if="canResetPassword" :href="route('password.request')" class="d-block mb-3">
          Forgot your password?
        </inertia-link>

        <a class="d-block account-link font-weight-bold" href="https://mobiletoolnetwork.com/register/">Don't have an account? Join us today!</a>
      </div>
    </form>
  </jet-authentication-card>

  <div class="container">
    <Vendors />
  </div>
</template>

<script>
  import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
  import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
  import JetButton from '@/Jetstream/Button'
  import JetInput from '@/Jetstream/Input'
  import JetCheckbox from '@/Jetstream/Checkbox'
  import JetLabel from '@/Jetstream/Label'

  import moment from 'moment'
  import moment_timezone from 'moment-timezone'
  import InteractiveInput from '@/Shared/InteractiveInput'
  import Vendors from '@/Components/General/Vendors'

  export default {
    components: {
      JetAuthenticationCard,
      JetAuthenticationCardLogo,
      JetButton,
      JetInput,
      JetCheckbox,
      JetLabel,
      Vendors,
      InteractiveInput
    },
    props: {
      canResetPassword: Boolean,
      status: String
    },
    data() {
      return {
        isOffline: false,
        form: this.$inertia.form({
          email: '',
          password: '',
          user_timezone: null,
          remember: true
        })
      }
    },
    created() {
      this.moment = moment
    },
    methods: {
      submit() {
        this.form.user_timezone = this.moment.tz.guess()
        
        this.form
          .transform(data => ({
            ... data,
            remember: this.form.remember ? 'on' : ''
          }))
          .post(this.route('login'), {
            onFinish: () => {
              this.form.reset('password')

              // Check if user is offline while logging in
              axios.get(route('logindata'))
                .then(() => this.isOffline = false)
                .catch(exception => {
                  if (exception.message.toLowerCase().includes('network error')) {
                    this.isOffline = true 
                    this.$page.props.errors = []
                  }
                })
            }
          })
      }
    }
  }
</script>

<style scoped>
  .account-link {
    font-size: 20px;
  }
</style>